module.exports = __webpack_public_path__ + "img/planung-min.a01a6fb1.jpg";